import { secureFetch } from './auth'
import { HttpError, failureMessage } from './orders-api'

// R4 — Bilal's HOP "Dispatch" surface: the same sendOut Nour has on pos, plus reassign
// for a run already on the road. Online only (no idb-queue wiring — these are HOP-side
// reads/writes on a screen that is itself gated behind a connection check elsewhere).

export interface ReadyToSendOrder {
  id: string
  shortCode: string | null
  customerName: string | null
  deliveryZoneName: string | null
  readyAt: string
}

export interface DispatchDriver {
  id: string
  name: string
  busy: boolean
}

export interface ActiveRunStop {
  orderId: string
  shortCode: string | null
  status: 'PENDING' | 'PICKED_UP' | 'DELIVERED' | 'EXCEPTION' | 'CANCELLED'
}

export interface ActiveRun {
  id: string
  status: 'ASSIGNED' | 'IN_PROGRESS'
  driver: { id: string; name: string } | null
  stops: ActiveRunStop[]
}

export async function fetchReadyToSend(): Promise<ReadyToSendOrder[]> {
  const res = await secureFetch('/api/dispatch/ready')
  if (!res.ok) throw new HttpError(await failureMessage(res), res.status)
  return res.json() as Promise<ReadyToSendOrder[]>
}

export async function fetchDrivers(): Promise<DispatchDriver[]> {
  const res = await secureFetch('/api/dispatch/drivers')
  if (!res.ok) throw new HttpError(await failureMessage(res), res.status)
  return res.json() as Promise<DispatchDriver[]>
}

export async function fetchActiveRuns(): Promise<ActiveRun[]> {
  const res = await secureFetch('/api/dispatch/runs/active')
  if (!res.ok) throw new HttpError(await failureMessage(res), res.status)
  return res.json() as Promise<ActiveRun[]>
}

export async function sendOut(orderIds: string[], driverId: string): Promise<{ id: string }> {
  const res = await secureFetch('/api/dispatch/runs', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderIds, driverId }),
  })
  if (!res.ok) throw new HttpError(await failureMessage(res), res.status)
  return res.json() as Promise<{ id: string }>
}

export async function reassignRun(runId: string, driverId: string): Promise<{ id: string }> {
  const res = await secureFetch(`/api/dispatch/runs/${runId}/reassign`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ driverId }),
  })
  if (!res.ok) throw new HttpError(await failureMessage(res), res.status)
  return res.json() as Promise<{ id: string }>
}

const DISPATCH_ROLES = ['hop', 'admin']

export function canSeeDispatch(roles: string[]): boolean {
  return roles.some((r) => DISPATCH_ROLES.includes(r))
}
